export default __webpack_public_path__ + "static/media/icon_egyptianFeet_left.d2c2b865.png";